export enum AdvancedSettingsEvent {
    OrgAdvancedSettings = 'Portal.OrgAdvancedSettings',
}
